import * as React from "react";
const SvgFiBrandsCreativeCommonsNd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons-nd_svg__a)">
      <path
        fill="#151A2D"
        d="M11.979 0q5.036 0 8.528 3.493Q23.999 6.964 24 12t-3.429 8.443Q16.95 24 11.979 24q-4.864 0-8.443-3.536Q0 16.929 0 12q0-4.907 3.536-8.507Q7.028 0 11.979 0m.042 2.164q-4.093 0-6.921 2.893Q2.164 8.036 2.164 12q0 4.007 2.914 6.9 2.914 2.914 6.943 2.914 4.007 0 6.986-2.936 2.829-2.742 2.829-6.879 0-4.114-2.871-6.943-2.851-2.891-6.944-2.892m4.522 7.007v2.057H7.821V9.171zm0 3.858v2.057H7.821v-2.057z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-nd_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsNd;
